const ARTICLES = [
  {
    tag: "Field Notes",
    title: "Three days in Yirgacheffe with Adem",
    excerpt:
      "Under a corrugated roof at 2,000 meters, we cupped fourteen washed lots. What we learned about elevation, water, and patience.",
    image:
      `${import.meta.env.BASE_URL}localized/editorial-ethiopia-01.jpg`,
    read: "8 min read",
    date: "July 09, 2026",
  },
  {
    tag: "Brew Guide",
    title: "The unhurried pour-over, revisited",
    excerpt:
      "We&apos;ve been quietly refining our house pour-over recipe. Here&apos;s what six months of experiments taught us about grind, pour speed, and letting go.",
    image:
      `${import.meta.env.BASE_URL}localized/editorial-pourover-01.jpg`,
    read: "6 min read",
    date: "June 22, 2026",
  },
  {
    tag: "Craft",
    title: "Why we still roast in twelve-kilo drums",
    excerpt:
      "Bigger drums promise efficiency. Smaller ones deliver something more precious — the ability to hear the beans change their mind.",
    image:
      `${import.meta.env.BASE_URL}localized/editorial-drum-01.jpg`,
    read: "5 min read",
    date: "June 04, 2026",
  },
];

export default function Editorial() {
  return (
    <section id="editorial" className="w-full bg-background-50 py-24 md:py-32 px-6 md:px-10 lg:px-14">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-14 reveal">
          <div>
            <span className="text-xs tracking-[0.35em] uppercase text-accent-700">The Journal</span>
            <h2 className="font-heading text-4xl md:text-5xl lg:text-6xl text-primary-950 mt-4 leading-tight">
              Notes on coffee, <em>slowly written.</em>
            </h2>
          </div>
          <a
            href="#editorial"
            className="text-sm text-foreground-700 hover:text-accent-700 transition-colors cursor-pointer whitespace-nowrap inline-flex items-center gap-2 border-b border-foreground-400 pb-1 w-fit"
          >
            <span>Browse the archive</span>
            <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center"></i>
          </a>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 lg:gap-10">
          {ARTICLES.map((a, idx) => (
            <article
              key={a.title}
              className="group flex flex-col reveal"
              style={{ transitionDelay: `${idx * 80}ms` }}
            >
              <div className="relative h-80 md:h-96 overflow-hidden rounded-lg mb-6">
                <img
                  src={a.image}
                  alt={a.title}
                  className="w-full h-full object-cover object-top transition-transform duration-1000 group-hover:scale-105"
                />
                <span className="absolute top-4 left-4 text-[10px] tracking-[0.3em] uppercase bg-background-50 text-primary-900 px-3 py-1.5 rounded-full">
                  {a.tag}
                </span>
              </div>
              <div className="flex items-center gap-3 text-xs text-foreground-500 mb-3">
                <span>{a.date}</span>
                <span className="w-1 h-1 rounded-full bg-foreground-400"></span>
                <span>{a.read}</span>
              </div>
              <h3 className="font-heading text-2xl md:text-3xl text-primary-950 mb-3 leading-snug group-hover:text-accent-700 transition-colors">
                {a.title}
              </h3>
              <p className="text-foreground-700 leading-relaxed text-sm mb-5">{a.excerpt}</p>
              <a
                href="#editorial"
                className="text-sm text-primary-900 hover:text-accent-700 transition-colors cursor-pointer whitespace-nowrap inline-flex items-center gap-2 border-b border-primary-900 pb-1 w-fit"
              >
                <span>Read the piece</span>
                <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center"></i>
              </a>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}